import { render, staticRenderFns } from "./register.vue?vue&type=template&id=3567a766"
import script from "./register.js?vue&type=script&lang=js&external"
export * from "./register.js?vue&type=script&lang=js&external"
import style0 from "./register.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./register.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports